// src/pages/BranchTransferList/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import BranchTransferFilters from "./components/BranchTransferFilters";
import BranchTransferTable from "./components/BranchTransferTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportBranchTransferCsv } from "./components/exportBranchTransferCsv";

const { Title } = Typography;

const BranchTransferList = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list } = useSelector((state) => state.branchTransferList);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Branch Transaction Transfer List Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportBranchTransferCsv({
      list,
      title:    "Branch Transfer List",
      filename: "branch_transfer_list",
    });
  };

  const hasData = list.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Branch Transfer List</Title>}
        extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <BranchTransferFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <BranchTransferTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Branch Transfer List"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <BranchTransferTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default BranchTransferList;
